// extracted by mini-css-extract-plugin
module.exports = {"root":"az_kI","disabled":"az_lI","input":"az_mI","checkmark-container":"az_nI","checkmark-border":"az_oI","checkmark-box":"az_pI","checkmark":"az_qI","label-text":"az_rI"};